import classNames from 'classnames';
import React from 'react';

import {Image} from '@udemy/react-core-components';

import styles from './value-prop.module.less';

export interface ValuePropProps {
    className?: string;
    content: string;
    heading: string;
    imgSrc: {
        desktopSrc: string;
        desktopSrc2x: string;
        mobileSrc: string;
    };
}

export const ValueProp = ({imgSrc, heading, content, className}: ValuePropProps) => {
    const {mobileSrc, desktopSrc, desktopSrc2x} = imgSrc;

    return (
        <div className={classNames(className, styles['value-prop'])}>
            <div className={styles['image-container']}>
                <Image
                    src={mobileSrc}
                    width={620}
                    height={350}
                    alt={''}
                    data-purpose="mobile-image"
                    className={styles['hide-on-desktop']}
                />
                <Image
                    src={desktopSrc}
                    srcSet={`${desktopSrc} 1x, ${desktopSrc2x} 2x`}
                    width={700}
                    height={350}
                    alt={''}
                    data-purpose="desktop-image"
                    className={styles['hide-on-mobile']}
                />
            </div>

            <div className={styles['text']}>
                <h2 className="ud-heading-xl">{heading}</h2>
                <p>{content}</p>
            </div>
        </div>
    );
};
